import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const OTT = ({
  height = 24,
  width = 24,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 2H13.5C13.7761 2 14 2.22386 14 2.5V10.5C14 10.7761 13.7761 11 13.5 11H2.5C2.22386 11 2 10.7761 2 10.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H13.5C14.3284 1 15 1.67157 15 2.5V10.5C15 11.2577 14.4382 11.8842 13.7084 11.9856L14.5724 13.7138C14.7305 14.0299 14.6024 14.4144 14.2862 14.5724C13.9701 14.7305 13.5856 14.6024 13.4276 14.2862L12.4276 12.2862L12.2845 12H3.71555L3.57244 12.2862L2.57244 14.2862C2.41436 14.6024 2.02993 14.7305 1.71379 14.5724C1.39764 14.4144 1.2695 14.0299 1.42757 13.7138L2.29164 11.9856C1.56183 11.8842 1 11.2577 1 10.5V2.5Z"
      fill={getColor(color, isColorInherited)}
    />
    <rect x="3" y="3" width="10" height="7" rx="0.5" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
